(() => {
  let isRefreshing = false;
  let canRefresh = true;
  let refreshTimeout = null;
  let isProcessing = false;

  function toggleButtons(enable) {
    document.querySelectorAll('.cart__quantity-minus, .cart__quantity-plus').forEach(btn => {
      btn.disabled = !enable;
      btn.style.pointerEvents = enable ? '' : 'none';
      btn.style.opacity = enable ? '' : '0.5';
    });
  }

  function doRefresh() {
    if (!canRefresh || isRefreshing) return;
    
    isRefreshing = true;
    canRefresh = false;
    
    const cartDrawer = document.querySelector('[data-cart-drawer], .drawer, [data-drawer]');
    if (cartDrawer) {
      cartDrawer.style.transition = 'opacity 0.2s ease';
      cartDrawer.style.opacity = '0.7';
    }
    
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    
    setTimeout(() => {
      if (cartDrawer) {
        cartDrawer.style.opacity = '1';
        setTimeout(() => {
          cartDrawer.style.transition = '';
        }, 200);
      }
      isRefreshing = false;
      setTimeout(() => canRefresh = true, 2000);
    }, 500);
  }

  document.addEventListener('theme:product:added', () => {
    if (isProcessing) return;
    if (refreshTimeout) clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(doRefresh, 1500);
  });

  document.body.addEventListener('click', (e) => {
    const button = e.target.closest('.cart__quantity-minus, .cart__quantity-plus');
    if (button && !isProcessing) {
      isProcessing = true;
      toggleButtons(false);
      if (refreshTimeout) clearTimeout(refreshTimeout);
    }
  }, true);

  document.addEventListener('theme:cart:change', () => {
    if (!isProcessing) return;
    if (refreshTimeout) clearTimeout(refreshTimeout);
    
    refreshTimeout = setTimeout(() => {
      isProcessing = false;
      toggleButtons(true);
      doRefresh();
      
      setTimeout(() => {
        doRefresh();
      }, 2000);
      
      refreshTimeout = null;
    }, 500);
  });

  window.refreshCartDrawer = doRefresh;
})();